import { z } from 'zod';
import {
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';
import type { NodeCfg } from '../nodes';

export const isduReadNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('isduRead'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        channelNumber: z.number(),
        /** keyed by variable id, value is the data required to interface with the isdu index */
        isduVariables: z.record(z.object({
            // human readable name from the iodd file. for display purposes only
            name: z.string(),
            // the applet node needs all possible isdu variables to know what its available options are. we use this boolean to signal if the node intends on interfacing with it
            tracked: z.boolean(),
            dataKind: z.union([ z.literal('string'), z.literal('number'), z.literal('boolean') ]),
        })),
    })),
}));
interface ISDUReadCfgSchema extends z.infer<typeof isduReadNodeCfgSchema> {}

export const isduReadNodeSocketCfg = {
    controlSockets: {
        inputs: (_cfg: NodeCfg<'isduRead'>) => {
            const ret: {
                trigger: 'event';
            } = {
                trigger: 'event',
            };
            return ret;
        },
        outputs: (_cfg: NodeCfg<'isduRead'>) => {
            const ret: {
                response: 'event';
            } = {
                response: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: (cfg: NodeCfg<'isduRead'>) => {
            const ret: Record<`output_${string}`, 'string' | 'number' | 'boolean'> = {};
            for (const [ variableId, variableDetails ] of Object.entries(cfg.controlValues.isduVariables)) {
                if (variableDetails.tracked) {
                    ret[`output_${variableId}`] = variableDetails.dataKind;
                }
            }
            return ret;
        },
        inputs: (_cfg: NodeCfg<'isduRead'>) => {
            return {};
        },
    },
} satisfies NodeSocketCfg<ISDUReadCfgSchema>;
